import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { UserInactivityInterceptor } from './interceptors/user-inactivity.interceptor';
import { OrderListPipe } from './pipes/order-list.pipe';
import { RoleRestrictionPipe } from './pipes/role-restriction.pipe';
import { AuthService } from './services/auth.service';

@NgModule({
  declarations: [RoleRestrictionPipe, OrderListPipe],
  imports: [CommonModule],
  providers: [
    AuthService,
    RoleRestrictionPipe,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserInactivityInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

  ],
  exports: [RoleRestrictionPipe, OrderListPipe],
})
export class CoreModule {
  static forChild(){
    return {
      ngModule: CoreModule,
    };
  }
  static forRoot(firebaseOptions : any): ModuleWithProviders<any> {
    return {
      ngModule: CoreModule,
      providers: [{ provide: FIREBASE_OPTIONS, useValue: firebaseOptions }],
    };
  }
}